var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.4395 1.4395C1 1.8785 1 2.586 1 4V8C1 9.414 1 10.1215 1.4395 10.5605C1.8785 11 2.586 11 4 11H8C9.414 11 10.1215 11 10.5605 10.5605C11 10.1215 11 9.414 11 8V4C11 2.586 11 1.8785 10.5605 1.4395C10.1215 1 9.414 1 8 1H4C2.586 1 1.8785 1 1.4395 1.4395ZM8.916 4.7775C8.9896 4.66717 9.01635 4.53212 8.99038 4.40207C8.9644 4.27201 8.88783 4.1576 8.7775 4.084C8.66717 4.0104 8.53212 3.98365 8.40207 4.00962C8.27201 4.0356 8.1576 4.11217 8.084 4.2225L6.562 6.506L6.3325 6.047C5.989 5.3605 5.032 5.3005 4.606 5.9395L3.084 8.2225C3.0104 8.33283 2.98365 8.46788 3.00962 8.59793C3.0356 8.72799 3.11217 8.8424 3.2225 8.916C3.33283 8.9896 3.46788 9.01635 3.59793 8.99038C3.72799 8.9644 3.8424 8.88783 3.916 8.7775L5.438 6.4945L5.6675 6.953C6.011 7.64 6.968 7.6995 7.394 7.0605L8.916 4.7775Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiq);
export default __webpack_public_path__ + "static/media/liq.3d54ff3042f4bed938d61a8eebc95b16.svg";
export { ForwardRef as ReactComponent };